// extracted by mini-css-extract-plugin
export default {"centered":"Button_centered__A1mES","leftIcon":"Button_leftIcon__GBfAR","rightIcon":"Button_rightIcon__ZXwks"};